import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  formData: {
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: '',
  },
  isSubmitting: false,
  submitSuccess: false,
  submitError: null,
};

const contactSlice = createSlice({
  name: 'contact',
  initialState,
  reducers: {
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    setSubmitting: (state, action) => {
      state.isSubmitting = action.payload;
    },
    setSubmitSuccess: (state, action) => {
      state.submitSuccess = action.payload;
      state.submitError = null;
    },
    setSubmitError: (state, action) => {
      state.submitError = action.payload;
      state.submitSuccess = false;
    },
    resetForm: (state) => {
      state.formData = initialState.formData;
      state.submitSuccess = false;
      state.submitError = null;
    },
  },
});

export const { 
  updateFormData, 
  setSubmitting, 
  setSubmitSuccess, 
  setSubmitError, 
  resetForm 
} = contactSlice.actions;
export default contactSlice.reducer;
